import FormSubmitButton from '../../../forms/FormSubmitButton';
import FacebookLoginService from './FacebookLoginService';
import ScreenReaderLoadingMessages from '../../../utils/screen-reader/ScreenReaderLoadingMessages';
import announce from '../../../utils/screen-reader/announce';

function init($form:HTMLFormElement) {
  const $btnSubmit = $form.querySelector<HTMLButtonElement>('[type=submit]')!;

  let isSubmitting = false;

  $form.addEventListener('submit', async (event) => {
    event.preventDefault();

    if (isSubmitting) {
      return;
    }

    isSubmitting = true;

    window.tnew.ui.messaging.clearErrors();

    FormSubmitButton.applyBusyStyling($btnSubmit, { disableElement: false });

    announce(ScreenReaderLoadingMessages.Start);

    const returnUrl = new URLSearchParams(document.location.search).get('returnUrl') || '';

    let response;

    try {
      response = await FacebookLoginService.login(returnUrl);
    } catch (exception) {
      window.location.href = '/error';
      return;
    }

    if (response.isSuccessful) {
      window.location.href = response.redirectUrl;
      return;
    }

    isSubmitting = false;

    FormSubmitButton.resetButtonStyling($btnSubmit);

    window.tnew.ui.messaging.addError(response.errorMessage, true);
  });
}

export default {
  init,
};
